import { Record as ImmutableRecord } from 'immutable';
// @ts-expect-error untyped module UIComponents
import * as SimpleDate from 'UIComponents/core/SimpleDate';
import I18n from 'I18n';
export const BackfillDurationTypes = {
  LAST_N_DAYS: 'LAST_N_DAYS',
  CUSTOM_DATE: 'CUSTOM_DATE',
  ALL_TIME: 'ALL_TIME'
};
export const BackfillDurationRanges = {
  LAST_THIRTY_DAYS: 'LAST_THIRTY_DAYS',
  LAST_SIXTY_DAYS: 'LAST_SIXTY_DAYS',
  LAST_NINETY_DAYS: 'LAST_NINETY_DAYS',
  ALL_TIME: 'ALL_TIME',
  CUSTOM_DATE: 'CUSTOM_DATE'
};
const simpleDateTypeToDaysAgo = {
  [BackfillDurationRanges.LAST_THIRTY_DAYS]: 30,
  [BackfillDurationRanges.LAST_SIXTY_DAYS]: 60,
  [BackfillDurationRanges.LAST_NINETY_DAYS]: 90
};
const daysAgoToSimpleDateType = {
  30: BackfillDurationRanges.LAST_THIRTY_DAYS,
  60: BackfillDurationRanges.LAST_SIXTY_DAYS,
  90: BackfillDurationRanges.LAST_NINETY_DAYS
};
function timestampFromSimpleDate(simpleDate) {
  return SimpleDate.toMomentPortalTz(simpleDate).valueOf();
}
function simpleDateFromTimestamp(timestamp) {
  return SimpleDate.fromMoment(I18n.moment.portalTz(timestamp));
}
export default class AssociationBackfillDuration extends ImmutableRecord({
  type: BackfillDurationTypes.LAST_N_DAYS,
  daysAgo: 30,
  timestamp: null
}, 'AssociationBackfillDuration') {
  getRange() {
    const backfillType = this.get('type');
    if (backfillType === BackfillDurationTypes.ALL_TIME) {
      return BackfillDurationRanges.ALL_TIME;
    } else if (backfillType === BackfillDurationTypes.CUSTOM_DATE) {
      return BackfillDurationRanges.CUSTOM_DATE;
    } else {
      return daysAgoToSimpleDateType[this.get('daysAgo')];
    }
  }
  setRange(rangeType) {
    let type = BackfillDurationTypes.LAST_N_DAYS;
    let timestamp = null;
    if (rangeType === BackfillDurationRanges.ALL_TIME) {
      type = BackfillDurationTypes.ALL_TIME;
    } else if (rangeType === BackfillDurationRanges.CUSTOM_DATE) {
      type = BackfillDurationTypes.CUSTOM_DATE;
      timestamp = timestampFromSimpleDate(SimpleDate.now());
    }
    return new AssociationBackfillDuration({
      type,
      daysAgo: simpleDateTypeToDaysAgo[rangeType] || null,
      timestamp
    });
  }
  getCustomDate() {
    const timestamp = this.get('timestamp');
    return timestamp ? simpleDateFromTimestamp(timestamp) : null;
  }
  setCustomDate(simpleDate) {
    return this.set('timestamp', simpleDate ? timestampFromSimpleDate(simpleDate) : null);
  }
}